import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CustomToastProvider } from './contexts/CustomToastContext';
import { UserContextProvider } from './contexts/UserContext';
import { KalpProductsProvider } from './contexts/KalpProductsContext';
import App from './App';
import 'react-datepicker/dist/react-datepicker.css';
import './index.scss';



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const url = window.location.href
const match = url.match(/redirect_url=([^#]*)/);


if(match){

console.log( decodeURIComponent(match[1]) )
// console.log(urlParams.toString())
// console.log(urlParams.get('redirect_url'))


  sessionStorage.setItem('redirect_url', decodeURIComponent(match[1])||'')
}else{
  

  sessionStorage.clear()
}


if(match?.[1]){

  let urlObj = new URL(decodeURIComponent(match[1]) ||'');
  let referralCode = urlObj.searchParams.get("referralCode");
  
  if(referralCode){
    sessionStorage.setItem('referralCode', referralCode||'')
  }
}
const queryString=window.location.search
const urlParams = new URLSearchParams(queryString);
if(urlParams.get('token') && urlParams.get('refresh_token') ){




  localStorage.setItem("access_token", urlParams.get('token')||'');
  localStorage.setItem("refresh_token",urlParams.get('refresh_token')||'');
}
if(urlParams.get('pathType')){
sessionStorage.setItem('pathType', urlParams.get('pathType')||'')
}

root.render(
  <React.StrictMode>
     

    <CustomToastProvider>
      <UserContextProvider>
        <AuthProvider>
          <KalpProductsProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
          </KalpProductsProvider>
        </AuthProvider>
      </UserContextProvider>
    </CustomToastProvider>

  </React.StrictMode>
);
